import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fuelLaneRateTypesAdapter = getAdapter({ idFieldName: 'value' });

const fuelLaneRateTypesSlice = createSlice({
  name: 'fuelLaneRateTypes',
  initialState: fuelLaneRateTypesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setFuelLaneRateTypes: (state, { payload: { fuelLaneRateTypes, source } }) => {
      fuelLaneRateTypesAdapter.setAll(state, fuelLaneRateTypes);
      state.source = source;
    }
  }
});

const selectors = fuelLaneRateTypesAdapter.getSelectors(({ fuelLaneRateTypes }) => fuelLaneRateTypes);

export const getFuelLaneRateTypes = state => selectors.selectAll(state);

export const { setFuelLaneRateTypes } = fuelLaneRateTypesSlice.actions;

export default fuelLaneRateTypesSlice.reducer;
